import React, { useEffect } from 'react'
import Spinner from '../components/utils/Spinner'
import AdOrderTemplate from '../utils/AdOrderTemplate'

const AdOrderContext = React.createContext({})

export default function AdOrder ({ restUrl, children, numberOfCities, pricePerWeek, pricePerWeekForAll }) {
  const ORDER_KEY = 'vk-ad-order'
  const [adOrder, setAdOrder] = React.useState(JSON.parse(localStorage.getItem(ORDER_KEY)))
  const [isLoading, setIsLoading] = React.useState(false)

  const setOrderFromRequest = function (requestOrder) {
    if (requestOrder.token === adOrder.token) {
      if (requestOrder.status !== 'draft' && requestOrder.status !== 'sent_to_payment_gateway') {
        // Order seems to be completed
        setAdOrder(AdOrderTemplate())
      } else {
        setAdOrder(requestOrder)
      }
    }
  }

  const fetchOrder = function (token) {
    setIsLoading(true)
    fetch(restUrl + token, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
      .then(response => response.json())
      .then(response => {
        if (response?.success === true && response?.data?.order) {
          let order = response.data.order
          if (order.status === 'draft' || order.status === 'sent_to_payment_gateway') {
            setOrderFromRequest(order)
          }else{
            setAdOrder(AdOrderTemplate())
          }
        }
      })
      .catch(() => {

      })
      .finally(() => setIsLoading(false))
  }

  const calcWeeks = function (adOrder) {
    let weeks = Math.ceil(Math.ceil((new Date(adOrder.date_to) - new Date(adOrder.date_from)) / 86400000) / 7)
    if (typeof weeks !== 'number' || isNaN(weeks)) {
      weeks = 1
    }

    return weeks
  }

  const calcPrice = function (adOrder) {
    let price = parseInt(pricePerWeek) * adOrder.cities.length * adOrder.weeks
    if (adOrder.cities.length === numberOfCities) {
      price = parseInt(pricePerWeekForAll) * adOrder.weeks
    }

    return price
  }

  React.useEffect(() => {
    localStorage.setItem(ORDER_KEY, JSON.stringify(adOrder))
  }, [adOrder])

  React.useEffect(() => {
    let status = adOrder?.status
    if (typeof status === 'string') {
      fetchOrder(adOrder.token)
    } else {
      setAdOrder(AdOrderTemplate())
    }
  }, [])

  return (
    <AdOrderContext.Provider value={{ adOrder, setAdOrder, isLoading, setIsLoading, calcPrice, calcWeeks, restUrl }}>
      {
        adOrder === null
          ? <Spinner/>
          : children
      }
    </AdOrderContext.Provider>
  )
}

export { AdOrderContext }
